import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import ClientRoutes from "./Routes";
import MainAdmin from "../components/admin/MainAdmin";
import AdminTodos from "../components/admin/AdminTodos";
import Invitation from "../components/common/invitation/Invitation";
import InvitationSelf from "../components/common/invitation/InvitationSelf";
import SuccessPage from "../components/common/payments/SuccessPage";
import Msgs from "../components/admin/Msgs";
import OptionalGuests from "../components/admin/OptionalGuests";
import AvivitTodos from "../components/admin/AvivitTodos";
import News from "../components/admin/News";
import SelfInvitation from "../components/common/invitation/SelfInvitation";

const AdminSwitc = () => {
  return (
    <Switch>
      <Route
        path={ClientRoutes.Admin.main}
        component={(props) => <MainAdmin {...props} />}
      />
      <Route
        path={ClientRoutes.Admin.avivit}
        component={(props) => <AvivitTodos {...props} />}
      />
      <Route
        path={ClientRoutes.Admin.news}
        component={(props) => <News {...props} />}
      />
      <Route
        path={ClientRoutes.Admin.todos}
        component={(props) => <AdminTodos {...props} />}
      />
      <Route
        path={ClientRoutes.Admin.msg}
        component={(props) => <Msgs {...props} />}
      />
      <Route
        path={ClientRoutes.Admin.guests}
        component={(props) => <OptionalGuests {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.payment}
        component={(props) => <SuccessPage {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.invitation}
        component={(props) => <Invitation {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.selfInvitation}
        component={(props) => <SelfInvitation {...props} />}
      />
      <Redirect from="/" to={ClientRoutes.Admin.main} />
    </Switch>
  );
};

export default AdminSwitc;
